import Image from '@data/models/Image';
import { Flex, useMediaQuery, useTheme } from '@chakra-ui/react';
import BEImageList from '@molecules/BEImageList';
import Button from '@molecules/Button';
import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { useState } from 'react';
import {
  StyledGalleryContainer,
  StyledGalleryOriginal,
  StyledGalleryThumbnail,
} from './StyledGallery';

export interface GalleryProps {
  index?: number;
  images: Image[];
  handleClickDetails?: () => void;
}

const useResponsive = () => {
  const theme = useTheme();
  const breakpoints = theme.breakpoints;

  const [isBetweenMDAndLG] = useMediaQuery(
    `(min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg})`
  );

  const [isBetweenLGAndXL] = useMediaQuery(
    `(min-width: ${breakpoints.lg}) and (max-width: ${breakpoints.xl})`
  );

  const [isBetweenXLAnd2XL] = useMediaQuery(
    `(min-width: ${breakpoints.xl}) and (max-width: 1500px)`
  );

  if (isBetweenMDAndLG) {
    return 640;
  }

  if (isBetweenLGAndXL) {
    return 800;
  }

  if (isBetweenXLAnd2XL) {
    return 1000;
  }

  return 1280;
};

const Gallery = ({
  index = 0,
  images,
  handleClickDetails,
  ...modalProps
}: ModalProps & GalleryProps) => {
  const [activeIndex, setActiveIndex] = useState(index);
  const width = useResponsive();

  return (
    <ModalComponent
      {...modalProps}
      hideFooter={true}
      hideHeader={true}
      width={width}
    >
      <Flex flexDirection="column" pt="8px">
        {handleClickDetails && (
          <div>
            <Button
              icon="arrow-left"
              variant="outline"
              size="md"
              onClick={handleClickDetails}
            >
              Accommodation Details
            </Button>
          </div>
        )}
        <StyledGalleryContainer
          gap="24px"
          mt={handleClickDetails ? '16px' : '32px'}
        >
          <StyledGalleryThumbnail>
            <BEImageList
              activeIndex={activeIndex}
              gap={16}
              images={images.map((image) => image.thumb)}
              isSelectable
              direction="vertical"
              onChange={setActiveIndex}
            />
          </StyledGalleryThumbnail>
          <StyledGalleryOriginal>
            <BEImageList
              activeIndex={activeIndex}
              gap={16}
              images={images.map((image) => image.src)}
              direction="vertical"
              responsive={{
                xs: {
                  itemHeight: 320,
                  multiplier: 0.55,
                },
                sm: {
                  itemHeight: 320,
                  multiplier: 0.55,
                },
                md: {
                  itemHeight: 320,
                  multiplier: 0.55,
                },
                lg: {
                  itemHeight: 420,
                  multiplier: 0.55,
                },
                xl: {
                  itemHeight: 500,
                  multiplier: 0.55,
                },
                '2xl': {
                  itemHeight: 630,
                  multiplier: 0.55,
                },
              }}
              onChange={setActiveIndex}
            />
          </StyledGalleryOriginal>
        </StyledGalleryContainer>
      </Flex>
    </ModalComponent>
  );
};

export default Gallery;
